import styled from 'styled-components';

export const SocialLinksContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
`;

export const SocialLink = styled.a.attrs({
  target: '_blank',
  rel: 'noopener noreferrer'
})`
  font-size: 1.5rem;
  transition: all 0.3s ease;
  display: inline-flex;
  border-radius: 50%;
  padding: 0.5rem;
  
  /* Varsayılan stil */
  color: white;
  background-color: rgba(255, 255, 255, 0.1);
  
  /* Facebook */
  &.facebook {
    color: #1877f2; /* Facebook mavisi */
    &:hover {
      background-color: rgba(24, 119, 242, 0.1);
      transform: translateY(-2px) scale(1.1);
    }
  }
  
  /* Instagram */
  &.instagram {
    color: #e4405f; /* Instagram pembe-kırmızısı */
    &:hover {
      background-color: rgba(228, 64, 95, 0.1);
      transform: translateY(-2px) scale(1.1);
    }
  }
  
  /* WhatsApp */
  &.whatsapp {
    color: #25d366; /* WhatsApp yeşili */
    &:hover {
      background-color: rgba(37, 211, 102, 0.1);
      transform: translateY(-2px) scale(1.1);
    }
  }

  @media (max-width: 768px) {
    font-size: 1.3rem;
    padding: 0.4rem;
  }

  @media (max-width: 480px) {
    font-size: 1.1rem;
    padding: 0.3rem;
  }
`;